import React from "react";
import { Link, graphql } from "gatsby";
import SEO from "../../../components/SEO";
import ContrastSection from "../../../components/ContrastSection";
import Layout from "../../../layouts/index";
import GetInTouchbtn from "../../../components/GetInTouchbtn";
import OurProcess from "../../../components/services/OurProcess";
import BookConsultation from "../../../components/BookConsultation";
import Img from "gatsby-image";
import Banner from "../../../images/services/software/banner.jpg";
import BannerUX from "../../../images/services/software/banner-ux.jpg";
import BannerWebdesign from "../../../images/services/software/banner-webdesign.jpg";
import BannerArchitect from "../../../images/services/software/banner-architect.jpg";
import BannerCloud from "../../../images/services/software/banner-cloud.png";
import BannerFullstack from "../../../images/services/software/banner-fullstack.jpg";
import ConsultationBanner from "../../../images/consultation.jpg";
import downloadFile from '../../../documents/Case-Study-Customised-Software-Development.pdf'
import caseStudyImg from "../../../images/Enterprise-Integration.jpg";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import plus from "../../../images/icons/plus.svg";
import minus from "../../../images/icons/minus.svg";
import productinnovation from "../../../images/product-innovation.jpg";
import IntroBanner from "../../../components/IntroBannerRevamp";
import { Container } from "reactstrap";
import SvgIconsSet from "../../../components/SvgIconsSet";

const SoftwareDevelopment = (props) => {
  return (
    <Layout bodyClass="page-services">
      <SEO
        keyword="Software Development"
        title="Customised Software Development"
        description="Product Innovation and Application Lifecycle Management (ALM)
                are a significant part of iTelaSoft's key offerings. We have
                assisted a great variety of organisations, from start-ups to
                large enterprises, in their product lifecycle journey. Currently
                we support a number of customers around the world, including
                Australia, Europe, and North America."
      />
      {/* <div className="intro intro-banner">
        <div className="intro-banner-img" id="up">
          <Img
            fluid={props.data.bannerImg.childImageSharp.fluid}
            loading="eager"
            fadeIn={true}
            alt="Banner Image"
            className="hero-banner"
          />
        </div>
        <div className="container">
          <div className="row hero-section">
            <div className="col-12 wrap-page-title">
              <h1 className="page-title">Customised Software Development</h1>
              <hr />
            </div>
          </div>
        </div>
      </div> */} <IntroBanner
        title="Customised Software Development"
        subtitle="Customise your solution to perfectly match your needs"
        image={Banner}
      />
      {/* <ContrastSection
        title="Customise your solution to perfectly match your needs"
        para={["Lorem ipsum dolor sit amet consectoli tur adipiscing elit semper dalar. Lorem ipsum dolor sit amet consectoli tur adipiscing elit semper dalar. Lorem ipsum dolor sit amet consectoli tur adipiscing elit semper dalar. Lorem ipsum dolor sit amet consectoli tur adipiscing elit semper dalar."]}
      /> */}
      <div className="container pb-6 section-2">
        <div className="row pt-6 mb-3">
          <div className="col-12">
            <h2 className="title-1">Our Services</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 pr-md-5">
            <img alt="product innovation" className="img-fluid" src={BannerUX} />
          </div>
          <div className="col-md-6 pt-3 pt-md-0 d-flex flex-column justify-content-center">
            <h2 className="title-2">User Experience &amp; Design</h2>
            <p>
              <strong>Boost engagement and satisfaction with customer centric design. </strong>
              <br/>
              We'll work with you to improve usability, increase user engagement and enhance your customer experience.
            </p>
          </div>
        </div>
        <div className="row pb-6">
          <div className="col-md-6 pr-md-5 order-md-2">
            <img alt="product innovation" className="img-fluid" src={BannerWebdesign} />
          </div>
          <div className="col-md-6 pt-3 pt-md-0 d-flex flex-column justify-content-center">
            <h2 className="title-2">Web Design &amp; Content Management Services</h2>
            <p>
              <strong>A well-structured website is the cornerstone of success. </strong>
              <br/>
              We'll work with you to create a high-quality website that matches your needs, ensures ease of maintenance and maximises cost efficiency.
            </p>
          </div>
        </div>
        <div className="row pb-6">
          <div className="col-md-6 pr-md-5">
            <img alt="product innovation" className="img-fluid" src={BannerArchitect} />
          </div>
          <div className="col-md-6 pt-3 pt-md-0 d-flex flex-column justify-content-center">
            <h2 className="title-2">Platform Architecture &amp; Technical Design</h2>
            <p>
              <strong>Enable scalability and efficiency for your needs now and in the future. </strong>
              <br/>
              We'll help you build a flexible and scalable framework that meets today's functional requirements and allows for ease of future enhancements. Seamless integration, process efficiency and a robust foundation come as standard in the architecture and design work we do.
            </p>
          </div>
        </div>
        <div className="row pb-6">
          <div className="col-md-6 pr-md-5 order-md-2">
            <img alt="product innovation" className="img-fluid" src={BannerCloud} />
          </div>
          <div className="col-md-6 pt-3 pt-md-0 d-flex flex-column justify-content-center">
            <h2 className="title-2">Cloud Engineering &amp; DevOps</h2>
            <p>
              <strong>Streamline your cloud investment. </strong>
              <br/>
              We offer a range of cloud infrastructure and integration services to automate, streamline and enhance operations. We optimise your cloud investment to deliver improved efficiency and reduced costs.
            </p>
          </div>
        </div>
        <div className="row pb-6">
          <div className="col-md-6 pr-md-5">
            <img alt="product innovation" className="img-fluid" src={BannerFullstack} />
          </div>
          <div className="col-md-6 pt-3 pt-md-0 d-flex flex-column justify-content-center">
            <h2 className="title-2">Full Stack Development</h2>
            <p>
              <strong>Create a cohesive and fully integrated solution. </strong>
              <br/>
              We offer both front-end and back-end development teams that work together seamlessly to deliver a fully functional and cost-effective solution.
            </p>
          </div>
        </div>
        <div className="getting-touch"><GetInTouchbtn textdce={'Free consultation'} /></div>
      </div>
      <Container>
        <OurProcess />
      </Container>
      <div className="wrap-case-study mt-3 pt-5">
        <Container>
          <div className="row pb-6">
            <div className="col-12">
              
              <div className="career">
                <div className="">
                  <div className="row justify-content-center">
                    <div className="col-12 col-lg-6 flex-column">
                      <div>
                        <h5 className="title-5">Case Study</h5>
                        <h3 className="title-3">HOW THIS HOME LOAN PROVIDER GOT 60 LOAN ACQUISITIONS DAILY</h3>
                        <p>
                          A prominent home loan provider in Australia improved loan acquisition rates by 1,700% by integrating with a decisioning engine. Read how it was done.
                        </p>
                      </div>
                      <a href={downloadFile} download class="btn btn-primary btn-icon-button mt-2 mb-3">
                        <span className="btn-text">Download Case Study</span>
                        <span className="btn-icon">
                          <SvgIconsSet.SideArrow />
                        </span>
                      </a>
                    </div>
                    <div className="col-12 col-lg-6">
                      <img alt="product innovation" className="img-fluid" src={caseStudyImg} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container> 
      </div>
      <Container className="my-6">
        <h2 className="title-1 mb-3">Book a free consultation</h2>
        <BookConsultation image={Banner} />
      </Container>
    </Layout>
  );
};

export const query = graphql`
  query {
    bannerImg: file(relativePath: { eq: "cloud-services-1024x597.png" }) {
      childImageSharp {
        fluid(maxWidth: 4000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
export default SoftwareDevelopment;
